export const images = {
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/10069544-4f2a-4dbf-8707-cbe4c77555f2.jpg",
  still: "https://cdn.magicpatterns.com/patterns/generated-images/45db1ad1-354e-4398-ad40-2accdc2db347.jpg",
  lab: "https://cdn.magicpatterns.com/patterns/generated-images/42a363b5-8a1c-4957-bb49-b3183814710b.jpg",
  botanicals: "https://cdn.magicpatterns.com/patterns/generated-images/593b266f-4c89-4cc7-aabb-028c62aa7ead.jpg",
  harvest: "https://cdn.magicpatterns.com/patterns/generated-images/9311e87c-ec51-4c9d-92d8-647e71dc6c9c.jpg",
};
